export const COMPANY_NAME = 'Sophinex Group';
export const COMPANY_FULL_NAME = `${COMPANY_NAME}, LLC`;
export const COMPANY_BUSINESS_HOURS_1 = 'Mon–Fri 10:00 am – 6:00 pm';
export const COMPANY_BUSINESS_HOURS_2 = 'Sat 10:00 am – 5:00 pm';
export const COMPANY_BUSINESS_HOURS_TZ = 'Central Time';
export const COMPANY_PHONE = '(251) 202-9402';
export const COMPANY_PHONE_ALT = '(251) 202-9402';
export const COMPANY_FAX = '(251) 202-9402';
export const COMPANY_EMAIL = 'info@sophinex.com';
export const COMPANY_ADDRESS = '4171 Lomac St';
export const COMPANY_ADDRESS_2 = 'Ste F #1110';
export const COMPANY_CITY = 'Montgomery';
export const COMPANY_STATE = 'AL';
export const COMPANY_POSTAL_CODE = '36106';
export const COMPANY_DESCRIPTION = `${ COMPANY_NAME } is a privately held and operated company with a great vision, expertise and experience of doing smart investments in real estate.`;
export const COMPANY_SLOGAN = 'As a privately held and operated business, we work hard to build trust and strong relationships with all of our clients and partners. That is why we remain at the top of our game.';

export const SERVICE_STATES = 'Alabama, Arkansas, Florida, Georgia, Kansas, Kentucky, North Carolina, Tennessee and Virginia';
export const SERVICE_STATES_SHORT = 'AL, AR, FL, GA, KS, KY, NC, TN and VA';

export const DISCLAIMER = 'The information provided on this website is for general informational purposes only and should not be considered as a substitute for legal advice from a qualified attorney. If you have any specific legal questions or concerns, please consult with a licensed attorney in your jurisdiction.';

export const COPYRIGHT = `© 2026 ${COMPANY_FULL_NAME}. All rights reserved.`;